"use strict";

exports.__esModule = true;
exports.notificationComponents = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _Notification = require("./Notification");
var _constants = require("./constants");
var _notificationComponen;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var UndoPartKindNotification = function UndoPartKindNotification(intl, _ref) {
  var onClick = _ref.onClick;
  var notificationArgs = {
    action: {
      onClick: onClick,
      intent: _core.Intent.PRIMARY,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, intl, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "UndoPartKindNotification.undo",
        defaultMessage: "Undo"
      }))
    },
    intent: _core.Intent.SUCCESS,
    message: /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, intl, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        color: "gainsboro"
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "UndoPartKindNotification.message",
      defaultMessage: "Part count added"
    })))
  };
  return _Notification.Notification.then(function (toaster) {
    return toaster.show(notificationArgs);
  });
};
var UndonePartKindNotification = function UndonePartKindNotification(intl) {
  var notificationArgs = {
    intent: _core.Intent.SUCCESS,
    message: /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, intl, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "UndonePartKindNotification.message",
      defaultMessage: "Part count undone"
    }))
  };
  return _Notification.Notification.then(function (toaster) {
    return toaster.show(notificationArgs);
  });
};
var CreateDashboardNotification = function CreateDashboardNotification(intl) {
  var notificationArgs = {
    icon: "tick",
    intent: _core.Intent.SUCCESS,
    message: /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, intl, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "CreateDashboardNotification.message",
      defaultMessage: "Successfully created dashboard"
    }))
  };
  return _Notification.Notification.then(function (toaster) {
    return toaster.show(notificationArgs);
  });
};
var UpdatedDashboardNotification = function UpdatedDashboardNotification(intl) {
  var notificationArgs = {
    icon: "tick",
    intent: _core.Intent.SUCCESS,
    message: /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, intl, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "UpdatedDashboardNotification.message",
      defaultMessage: "Successfully updated dashboard"
    }))
  };
  return _Notification.Notification.then(function (toaster) {
    return toaster.show(notificationArgs);
  });
};
var DeletedDashboardNotification = function DeletedDashboardNotification(intl) {
  var notificationArgs = {
    icon: "tick",
    intent: _core.Intent.SUCCESS,
    message: /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, intl, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "DeletedDashboardNotification.message",
      defaultMessage: "Successfully deleted dashboard"
    }))
  };
  return _Notification.Notification.then(function (toaster) {
    return toaster.show(notificationArgs);
  });
};
var DuplicatedDashboardNotification = function DuplicatedDashboardNotification(intl) {
  var notificationArgs = {
    icon: "tick",
    intent: _core.Intent.SUCCESS,
    message: /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, intl, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "DuplicatedDashboardNotificationons.message",
      defaultMessage: "Successfully duplicated dashboard"
    }))
  };
  return _Notification.Notification.then(function (toaster) {
    return toaster.show(notificationArgs);
  });
};
var notificationComponents = exports.notificationComponents = (_notificationComponen = {}, _notificationComponen[_constants.NOTIFICATION_UNDO_PART_KIND] = UndoPartKindNotification, _notificationComponen[_constants.NOTIFICATION_UNDONE_PART_KIND] = UndonePartKindNotification, _notificationComponen[_constants.NOTIFICATION_CREATED_DASHBOARD] = CreateDashboardNotification, _notificationComponen[_constants.NOTIFICATION_DELETED_DASHBOARD] = DeletedDashboardNotification, _notificationComponen[_constants.NOTIFICATION_UPDATED_DASHBOARD] = UpdatedDashboardNotification, _notificationComponen[_constants.NOTIFICATION_DUPLICATED_DASHBOARD] = DuplicatedDashboardNotification, _notificationComponen);